import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { SimpleNavbar } from '../../components/layout/SimpleNavbar';
import api from '../../services/api';

export const RegistrationCancelPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('cleaning'); // 'cleaning', 'cleaned', 'error'
  const [message, setMessage] = useState('Cancelling registration...');

  useEffect(() => {
    const sessionId = searchParams.get('session_id');
    const provider = searchParams.get('provider') || 'stripe';

    // Cleanup pending registration
    const cleanupRegistration = async () => {
      try {
        if (sessionId) {
          // Call API to cancel and cleanup pending registration
          await api.post('/auth/cancel-registration', {
            sessionId,
            provider
          });
        }

        setStatus('cleaned');
        setMessage('Registration cancelled successfully.');
      } catch (error) {
        console.error('Cleanup error:', error);
        // Even if cleanup fails, show cancelled message
        // Backend should have cleanup mechanisms
        setStatus('cleaned');
        setMessage('Registration cancelled.');
      }
    };

    cleanupRegistration();

    // Clear any stored payment session data
    localStorage.removeItem('pendingRegistrationId');
    localStorage.removeItem('paymentSessionId');
  }, [searchParams]);

  return (
    <div className="min-h-screen bg-common-gradient">
      <SimpleNavbar />

      <div className="flex items-center justify-center min-h-screen px-4">
        <div className="max-w-2xl w-full text-center">
          {status === 'cleaning' && (
            <>
              <div className="mb-8">
                <div className="inline-block animate-spin rounded-full h-16 w-16 border-b-4 border-cyan-400"></div>
              </div>
              <h1 className="text-4xl font-anton text-white mb-4">
                CANCELLING REGISTRATION
              </h1>
              <p className="text-gray-300 font-roboto text-lg">
                {message}
              </p>
            </>
          )}

          {(status === 'cleaned' || status === 'error') && (
            <>
              <div className="mb-8">
                <svg
                  className="w-20 h-20 text-yellow-400 mx-auto"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                  />
                </svg>
              </div>
              <h1 className="text-4xl font-anton text-white mb-4">
                REGISTRATION CANCELLED
              </h1>
              <p className="text-gray-300 font-roboto text-lg mb-8">
                {message}
              </p>
              <p className="text-gray-400 font-roboto text-sm mb-8">
                Your payment was not processed and no charges were made to your account.
              </p>

              <div className="space-y-4">
                <button
                  onClick={() => navigate('/auth/signup')}
                  className="px-8 py-4 bg-cyan-500 hover:bg-cyan-600 text-white font-anton text-lg rounded-xl transition-colors block mx-auto"
                >
                  START OVER
                </button>

                <button
                  onClick={() => navigate('/')}
                  className="text-gray-400 hover:text-cyan-400 font-roboto transition-colors"
                >
                  Go to Home
                </button>
              </div>

              <div className="mt-12 p-6 bg-slate-800/50 rounded-xl border border-slate-700">
                <h3 className="text-white font-anton text-xl mb-3">
                  NEED HELP?
                </h3>
                <p className="text-gray-300 font-roboto text-sm">
                  If you encountered any issues during registration or have questions about our plans, please contact our support team.
                </p>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default RegistrationCancelPage;
